export * from './entity-name/components';
export * from './entity-name/services/entity-name-search.service';
export * from './entity-name/types/Entity';
export * from './entity-name/view/entity-name-search.view';

